<template>
    <div>
        <!-- Proposal Generator Sales Tax Add/Edit Modal -->
        <div class="modal fade" id="pg-sales-tax-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"  aria-hidden="true" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 v-if="editing" class="modal-title text-black font-normal" id="exampleModalLongTitle">Edit custom sales tax rate</h5>
                        <h5 v-else class="modal-title text-black font-normal" id="exampleModalLongTitle">Add custom sales tax rate</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePGSalesTaxModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div>
                            <label class="text-black">Type</label>
                            <multiselect v-model="selectedPGSalesTaxType" :options="pgSalesTaxTypes" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Pick a type"></multiselect>
                        </div>
                        <div class="mt-2">
                            <label class="text-black">Name<span class="text-danger">*</span></label>
                            <input class="form-control" type="text" placeholder="Name" v-model="pgSalesTaxName">
                        </div>
                        <div class="mt-2" v-if="selectedPGSalesTaxType === 'Single'">
                            <label class="text-black">Rate</label>
                            <input class="form-control" @input="checkTaxRate('single', null, pgSalesTaxRate)" type="number" placeholder="%" min="0" max="100" v-model="pgSalesTaxRate">
                        </div>
                        <div class="mt-2" v-else>
                            <div class="mt-2" v-for="(pgSalesTaxCombined, index) in pgSalesTaxCombinedArray">
                                <hr>
                                <label class="text-black text-sm m-0">Rate {{index+1}}</label>
                                <div class="row m-0 p-0">
                                    <div class="col-1 d-flex align-items-center">
                                        <i title="Remove" @click="removeCombinedTax(index)" class="fa fa-times text-danger text-2xl cursor-pointer" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-11">
                                        <div class="w-100">
                                            <label class="text-black text-sm m-0">Nickname<span class="text-danger">*</span></label>
                                            <input class="form-control form-control-sm" type="text" placeholder="Name" v-model="pgSalesTaxCombined.pgSalesTaxName">
                                        </div>
                                        <div class="w-100 mt-2">
                                            <label class="text-black text-sm m-0">Rate</label>
                                            <input class="form-control form-control-sm" @input="checkTaxRate('combined', index, pgSalesTaxCombined.pgSalesTaxRate)" type="number" placeholder="%" max="100" v-model="pgSalesTaxCombined.pgSalesTaxRate">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <p class="text-sm text-teal w-full text-right cursor-pointer" @click="addCombinedTax()">+ Add another rate</p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="editing" type="button" class="btn btn-primary" @click="updatePGTax()">Update</button>
                        <button v-else type="button" class="btn btn-primary" @click="savePGTax()">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Proposal Generator Sales Tax Add/Edit Modal End -->
        <button class="btn btn-primary float-right mb-2" @click="openPGSalesTaxModal()">Add New</button>
        <!-- Proposal Generator Sales Tax Table -->
        <table class="table table-bordered table-responsive pg-sales-tax-table">
            <thead>
                <tr>
                    <th style="width: 50%; font-size: 15px; font-weight: 400;">Name</th>
                    <th style="width: 20%; font-size: 15px; font-weight: 400;">Type</th>
                    <th style="width: 20%; font-size: 15px; font-weight: 400;">Rate</th>
                    <th style="width: 10%; font-size: 15px; font-weight: 400;">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="allSalesTax.length > 0" v-for="salesTax in allSalesTax">
                    <td>
                        {{ salesTax.name }}
                        <span :class="(index > 0)? 'd-block ml-5 border-t-1':'d-block ml-5'" v-if="salesTax.type == 2" v-for="(rate, index) in salesTax.sales_tax_rates">
                            {{ rate.name }}
                        </span>
                    </td>
                    <td>
                        {{ (salesTax.type == 1)? 'Single':'Combined' }}
                    </td>
                    <td>
                        <span>
                            {{ salesTax.total_tax_rate }}%
                        </span>
                        <span :class="(index > 0)? 'd-block border-t-1 ml-4':'d-block ml-4'" v-if="salesTax.type == 2" v-for="(rate, index) in salesTax.sales_tax_rates">
                            {{ rate.rate }}%
                        </span>
                    </td>
                    <td>
                        <i title="Edit" class="fa fa-pencil text-lg col-5 text-teal cursor-pointer" aria-hidden="true" @click="editPGSalesTax(salesTax)"></i> <i title="Delete" class="fa fa-trash text-lg col-6 text-danger cursor-pointer" aria-hidden="true" @click="deletePGSalesTax(salesTax)"></i>
                    </td>
                </tr>
                <tr v-if="allSalesTax.length == 0">
                    <td colspan="11" class="text-center">No sales tax added yet</td>
                </tr>
            </tbody>
        </table>
        <!-- Proposal Generator Sales Tax Table End -->
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
    name: "pg-sales-tax-settings",
    props:[],
    components: {Multiselect},
    data() {
        return {
            allSalesTax: [],
            pgSalesTaxTypes: [
                'Single',
                'Combined'
            ],
            selectedPGSalesTaxType: 'Single',
            pgSalesTaxName: '',
            pgSalesTaxRate: null,
            pgSalesTaxCombinedArray: [
                {
                    id: null,
                    pgSalesTaxName: '',
                    pgSalesTaxRate: null,
                },
                {
                    id: null,
                    pgSalesTaxName: '',
                    pgSalesTaxRate: null,
                }
            ],
            editing: false,
            editTax: null,
        }
    },
    mounted(){
        $(document).ready(function() {
            $('.fa').tooltip();
        });
        this.getAllSalesTax();
    },
    methods: {
        openPGSalesTaxModal(){
            $('#pg-sales-tax-modal').modal('show');
        },
        closePGSalesTaxModal(){
            $('#pg-sales-tax-modal').modal('hide');
            this.editing = false;
            this.editTax = null;
            this.resetTaxData();
        },
        checkTaxRate(type, index, rate){

            if(type === 'single' && rate > 100){
                this.pgSalesTaxRate = 100;
                this.getToast().fire({
                    type: 'error',
                    title: 'Sales tax cannot exceed 100%'
                });
            }else{
                this.$nextTick(() => {
                    let rateArray = [];
                    this.pgSalesTaxCombinedArray.forEach(item => {
                        if(item.pgSalesTaxRate){
                            rateArray.push(item.pgSalesTaxRate);
                        }
                    });
                    let totalSum = 0;
                    rateArray.forEach((number) => {
                        totalSum = parseInt(totalSum)+parseInt(number);
                    });
                    if(parseInt(totalSum) > 100 || rate > 100){
                        this.pgSalesTaxCombinedArray[index].pgSalesTaxRate = null;
                        this.getToast().fire({
                            type: 'error',
                            title: 'Sales tax total amount cannot exceed 100%'
                        });
                    }
                })
            }

        },
        addCombinedTax(){
            this.pgSalesTaxCombinedArray.push(
                {
                    id: null,
                    pgSalesTaxName: '',
                    pgSalesTaxRate: null,
                }
            );
        },
        removeCombinedTax(index){
            if(this.pgSalesTaxCombinedArray.length > 1){
                this.pgSalesTaxCombinedArray.splice(index, 1);
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Minimum 1 rate is required'
                });
            }
        },
        resetTaxData(){
            this.selectedPGSalesTaxType = 'Single';
            this.pgSalesTaxName = '';
            this.pgSalesTaxRate = null;
            this.pgSalesTaxCombinedArray = [
                {
                    id: null,
                    pgSalesTaxName: '',
                    pgSalesTaxRate: null,
                },
                {
                    id: null,
                    pgSalesTaxName: '',
                    pgSalesTaxRate: null,
                }
            ];
        },
        savePGTax(){
            var checkData = this.checkData();
            if(checkData.status){
                let data = {
                    selectedPGSalesTaxType: this.selectedPGSalesTaxType,
                    pgSalesTaxName: this.pgSalesTaxName,
                    pgSalesTaxRate: this.pgSalesTaxRate,
                    pgSalesTaxCombinedArray: this.pgSalesTaxCombinedArray
                }
                axios.post(route('api.proposal-settings.sales-tax.add'), data).then(response => {
                    this.allSalesTax = response.data.allSalesTax;
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.closePGSalesTaxModal();
                });
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: checkData.message
                });
                return false;
            }
        },
        checkData(){
            if(this.pgSalesTaxName.trim() === ''){
                return {
                    message: 'Please add valid name',
                    status: false
                };
            }
            if(this.selectedPGSalesTaxType === 'Single'){
                if(this.pgSalesTaxRate == null || this.pgSalesTaxRate > 100){
                    return {
                        message: 'Please add valid tax rate',
                        status: false
                    };
                }else{
                    return {
                        status: true
                    }
                }
            }else{
                if(this.pgSalesTaxCombinedArray.length > 0){
                    let nameErrorArray = [];
                    let taxErrorArray = [];
                    this.pgSalesTaxCombinedArray.forEach((item, index) => {
                        let rateName = index+1;
                        if(item.pgSalesTaxName.trim() === ''){
                            nameErrorArray.push({
                                message: 'Please add valid name for rate '+ rateName,
                                status: false
                            });
                        }

                        if(item.pgSalesTaxRate == null || item.pgSalesTaxRate > 100){
                            taxErrorArray.push({
                                message: 'Please add valid tax rate for rate '+ rateName,
                                status: false
                            });
                        }
                    });
                    if(nameErrorArray.length > 0){
                        return nameErrorArray[0];
                    }
                    if(taxErrorArray.length > 0){
                        return taxErrorArray[0];
                    }
                }else{
                    return {
                        message: 'Minimum 1 combined tax is required',
                        status: false
                    };
                }
            }

            return {
                status: true
            }
        },
        getAllSalesTax(){
            axios.post(route('api.proposal-settings.sales-tax.get-all-sales-tax')).then(response => {
                this.allSalesTax = response.data.allSalesTax;
            });
        },
        editPGSalesTax(salesTax){
            this.editing = true;
            let salesTaxArray = [];
            if(salesTax.type == 2){
                salesTax.sales_tax_rates.forEach(item => {
                    salesTaxArray.push({
                        id: item.id,
                        pgSalesTaxName: item.name,
                        pgSalesTaxRate: item.rate,
                   })
                });
            }
            this.selectedPGSalesTaxType = (salesTax.type == 1)? 'Single':'Combined';
            this.pgSalesTaxName = salesTax.name;
            this.pgSalesTaxRate = (salesTax.type == 1)? salesTax.sales_tax_rates[0].rate:null;
            this.pgSalesTaxCombinedArray = (salesTax.type == 1)? []:salesTaxArray;
            this.editTax = salesTax;
            this.openPGSalesTaxModal();
        },
        deletePGSalesTax(salesTax){
            Swal.fire({
                title: 'Delete '+ salesTax.name,
                text: "Do you want to delete "+ salesTax.name+" sales tax",
                type: 'danger',
                showCancelButton: true,
                confirmButtonColor: '#cc1f1a',
                confirmButtonText: 'Delete'
            }).then((result) => {
                if (result.value) {
                    axios.post(route('api.proposal-settings.sales-tax.delete-sales-tax'), salesTax).then(response => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.allSalesTax = response.data.allSalesTax;
                    });
                }else{
                    return false;
                }
            });
        },
        updatePGTax(){
            this.$nextTick(() => {
                var checkData = this.checkData();
                if(checkData.status){
                    let data = {
                        salesTax: this.editTax,
                        selectedPGSalesTaxType: this.selectedPGSalesTaxType,
                        pgSalesTaxName: this.pgSalesTaxName,
                        pgSalesTaxRate: this.pgSalesTaxRate,
                        pgSalesTaxCombinedArray: this.pgSalesTaxCombinedArray
                    }
                    axios.post(route('api.proposal-settings.sales-tax.update'), data).then(response => {
                        this.allSalesTax = response.data.allSalesTax;
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.closePGSalesTaxModal();
                    });
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: checkData.message
                    });
                    return false;
                }
            });
        },
    },
    watch: {
        selectedPGSalesTaxType: function(value, newValue){
            if(value === 'Combined'){
                setTimeout(() => {
                    $('.fa').tooltip();
                }, 500);
            }

            if(value == null){
                this.selectedPGSalesTaxType = 'Single';
            }
        }
    }
};
</script>

<style>
.pg-sales-tax-table tbody tr td {
    font-size: 13px;
    font-weight: normal;
}
</style>
